<template>
  <section
    class="component-ac95c94b"
    resmed-component-name="explore_3col-line_text_link"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <div
      class="component"
      v-bind:class="{
        'is-cta-style-pill': acf.layout['cta-style'] === 'pill',
        'content-alignment-center':
          acf.layout['content-alignment'] === 'center',
        [`text-color-${acf.layout['text-color']}`]: true,
      }"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="
                acf.layout['content-alignment'] === 'center' ? 'center' : ''
              "
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
          </div>
        </div>

        <div class="row">
          <div
            class="item"
            v-for="(item, index) in acf.items"
            v-bind:class="{
              'col-md-6': acf.items.length === 2,
              'col-md-4': acf.items.length === 3,
            }"
          >
            <div class="content">
              <div class="content-body">
                <figure v-if="item.image" class="mb-4">
                  <img
                    class="img-fluid"
                    v-bind:src="item.image.sizes.large"
                    alt=""
                  />
                </figure>
                <h5 v-html="item.title"></h5>
                <p v-if="item.description" v-html="item.description"></p>
              </div>

              <div class="call-to-action">
                <a
                  v-if="acf.layout['cta-style'] === 'pill'"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-pill filled-red icon right-arrow"
                  >{{ item.cta.text }}</a
                >
                <a
                  v-if="acf.layout['cta-style'] === 'text'"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ item.cta.text }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ac95c94b", // explore_3col-line_text_link
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ac95c94b {
  // -->
}

.component {
  padding: 6rem 0 5rem 0;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content-body {
      padding-bottom: 1rem;
      margin-bottom: auto;
      height: 100%;
    }
  }

  h2 {
    position: relative;
    margin-bottom: 2rem;

    @extend %eyebrow-left;
  }

  h5 {
    margin-bottom: 0.725rem;
  }

  &.text-color-white {
    h2,
    h5,
    p {
      color: $cc-resmed-white;
    }

    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  &.is-cta-style-pill {
    .item {
      @media (min-width: 992px) {
        padding-bottom: 3.5rem;
      }
    }
  }

  &.content-alignment-center {
    h2,
    h5 {
      text-align: center;
    }

    h2 {
      @extend %eyebrow-center;
    }

    .item {
      text-align: center;
    }
    .content {
      @media (min-width: 992px) {
        padding: 0 1.75rem;
      }
    }
  }

  .item {
    margin-bottom: 3rem;

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: 768px) {
      margin-bottom: 0;
    }

    @media (min-width: 992px) {
      padding-bottom: 1rem;
    }

    figure {
      overflow: hidden;
      border-radius: 6px;
      box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    }
  }

  .call-to-action {
    .cta-plain {
      left: auto;
    }
  }
}
</style>